import type { NextPage } from "next";
import useTranslation from "next-translate/useTranslation";
import { Error } from "@/components/error/Error";
import Head from "next/head";
import { OGPPayments } from "@/components/ogp-payments/ogp-payments";
import { StreamName, useRegisterStream } from "@/modules/analytics";

const Page404: NextPage = () => {
  const { t } = useTranslation("web-payments");
  useRegisterStream(StreamName.NotFound);

  return (
    <>
      <Head>
        <title>{`${t`404_NOT_FOUND_TITLE`} | OneFootball`}</title>
        <OGPPayments
          title={t`OG_TITLE_PAGE_NOT_FOUND`}
          description="OneFootball"
        />
      </Head>

      <Error
        header={t`404_NOT_FOUND_HEADER`}
        subHeader={t`404_NOT_FOUND_ALT_TEXT`}
      />
    </>
  );
};

export default Page404;
